import React, { useState } from 'react'
import Sidebar from '../../../components/Sidebar/Sidebar';
import Header from '../../../components/Header/Header';
import Table from '../../../components/Table/Table';
import { Link } from 'react-router-dom';

const DraftCourse = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const courses = []

    return (

        <div className="flex dark:bg-dark  h-screen overflow-hidden">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main>
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <div className="mb-8">
                            <div className="flex-grow font-primary">
                                <section className=''>
                                    <div className="flex flex-col">
                                        <div className="flex flex-row justify-between items-center">
                                            <div className="relative">
                                            </div>
                                            <Link to="/premium-course/add-course" className="px-6 py-2 rounded-lg text-white bg-brand hover:bg-brand_50 w-fit ">Add Course</Link>
                                        </div>
                                        <div className="mt-6">
                                            {courses?.length > 0 ? (
                                                <Table showDelete={true} page="Courses" topics={courses} />
                                            ) : (
                                                <div className="flex justify-center items-center">
                                                    <h1 className="text-xl font-medium dark:text-zinc-200">There are no courses.</h1>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
}

export default DraftCourse